import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getPermissions } from '../api/user.service'
import { useAuthStore } from './auth.store'

export const usePermissionsStore = defineStore('permissions', () => {
  const permissions = ref([])
  const loaded = ref(false)

  function isGod() {
    const authStore = useAuthStore()
    return authStore.user?.roles?.includes('God') ?? false
  }

  function hasPermission(permission) {
    if (isGod()) return true
    return permissions.value.includes(permission)
  }

  function hasAnyPermission(perms) {
    if (isGod()) return true
    return perms.some(p => permissions.value.includes(p))
  }

  async function fetchPermissions(force = false) {
    if (loaded.value && !force) return permissions.value
    
    try {
      const response = await getPermissions()
      permissions.value = response.data || []
      loaded.value = true
      return permissions.value
    } catch (error) {
      console.error('Ошибка загрузки разрешений:', error)
      permissions.value = []
      return []
    }
  }

  function clearPermissions() {
    permissions.value = []
    loaded.value = false
  }

  return {
    permissions,
    loaded,
    hasPermission,
    hasAnyPermission,
    fetchPermissions,
    clearPermissions
  }
})
